export const formatEmployeeDisplay = (
  name?: string | null,
  employeeNo?: string | null,
) => {
  const parts = [name?.trim(), employeeNo?.trim()].filter(Boolean);
  return parts.length ? parts.join(' / ') : null;
};
